function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDoubleArrowActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "left-right-arrow",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon line",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    id: "primary",
    points: "17 19 20 16 17 13",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-2",
    "data-name": "primary",
    d: "M20,16H4",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-2",
    "data-name": "primary",
    d: "M4,8H20",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "primary-3",
    "data-name": "primary",
    points: "7 5 4 8 7 11",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoubleArrowActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/double_arrow_active.41bbd66b7c8930e574af07568bbb1044.svg";